import Request from './Request';

class Api {
    static url;
    static headers = {};
    static vueRouter;

    static get(path) {
        let r = new Request(path, 'GET');
        r.base = Api.url;
        r.headers = Api.headers;
        r.vueRouter = Api.vueRouter;

        return r;
    }

    static post(path) {
        let r = new Request(path, 'POST');
        r.base = Api.url;
        r.headers = Api.headers;
        r.vueRouter = Api.vueRouter;

        return r;
    }

    static put(path) {
        let r = new Request(path, 'PUT');
        r.base = Api.url;
        r.headers = Api.headers;
        r.vueRouter = Api.vueRouter;

        return r;
    }

    static delete(path) {
        let r = new Request(path, 'DELETE');
        r.base = Api.url;
        r.headers = Api.headers;
        r.vueRouter = Api.vueRouter;

        return r;
    }
}

export default Api;
